import { useState } from 'react';

const INITIAL_STATE = {
  index: 0,
  intervalId: null,
};

const DURATION = 2000;

/**
 * Hook to go to the next index on List<index> on hover
 * @param {List<images>} images
 * @param {number} hoverPeriod, default value 2000ms
 * @returns {number} index, {function} pauseImage, {function} nextImage
 */

const useHoverNextImage = (images, hoverPeriod = DURATION) => {
  const imageTotal = images?.length;
  const [current, setCurrent] = useState({ ...INITIAL_STATE });

  const nextImage = () => {
    if (!imageTotal) return;

    const iterate = (intervalId) => {
      const newIndex = current.index + 1 <= imageTotal ? current.index + 1 : 0;
      setCurrent(({ index }) => ({
        index: newIndex,
        intervalId,
      }));

      if (
        images?.[newIndex]?.file?.contentType?.indexOf('video') === -1 ||
        images?.[newIndex]?.resource_type === 'video'
      ) {
        const currentTimeout = setTimeout(
          () => iterate(currentTimeout),
          hoverPeriod
        );
      }
    };

    iterate(null);
  };

  const pauseImage = () => {
    if (!imageTotal) return;
    clearTimeout(current?.intervalId);
    setCurrent({ ...INITIAL_STATE });
  };

  return {
    index: current.index,
    pauseImage,
    nextImage,
  };
};

export default useHoverNextImage;
